<!-- 由 suu 创建于 2021-11-09 星期二 -->
<template>
  <div class="app-download" @click="downloadApp">
    <slot></slot>
    <van-overlay
      :show="showOpen"
      @click="showOpen = false"
      z-index="99"
      :lock-scroll="false"
    >
      <img
        class="ad-open"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-share-open"
        alt=""
      />
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {},

  data() {
    return {
      showFloat: false,
      showOpen: false, // 显示引导浏览器中打开
      clipboard: null,
      config: {
        H5_PRIVACY:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/agreement/privacy.html',
        H5_AGREEMENT:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/agreement/agreement.html',
        androidDownloadUrl:
          'https://a.app.qq.com/o/simple.jsp?pkgname=com.wegymer.betterwe',
        iosAppstoreUrl: 'https://apps.apple.com/cn/app/id1578889450'
      },
      downloadInWeixin: false,
      isWeiXin: false, // 是否是微信环境
      isAndroid: false,
      isIOS: false,
      inviteCode:
        this.$route.query.invitedCode || this.$route.query.inviteCode || ''
    }
  },

  computed: {
    sfrom() {
      return this.$route.query.sfrom || ''
    },
    androidDownloadUrl() {
      switch (this.sfrom) {
        case 'B420':
          return 'https://gymvue.gymcity.com.cn/betterwe_app_installs/BetterWe_v1.4.0_40_channel_B420.apk'
        case 'recall':
          return 'https://gymvue.gymcity.com.cn/betterwe_app_installs/BetterWe_v1.4.1_41_channel_ZHAOHUI.apk'
        case 'weekSummary':
          return 'https://gymvue.gymcity.com.cn/betterwe_app_installs/BetterWe_v1.5.8_58_channel_ZZJHB.apk'
        default:
          return 'https://a.app.qq.com/o/simple.jsp?pkgname=com.wegymer.betterwe'
      }
    },
    iosAppstoreUrl() {
      switch (this.sfrom) {
        case 'B420':
          return 'https://apps.apple.com/app/apple-store/id1578889450?pt=123007243&ct=B420&mt=8'
        case 'recall':
          return 'https://apps.apple.com/app/apple-store/id1578889450?pt=123007243&ct=ZHAOHUI&mt=8'
        case 'weekSummary':
          return 'https://apps.apple.com/app/apple-store/id1578889450?pt=123007243&ct=ZZJHB&mt=8'
        default:
          return 'https://apps.apple.com/cn/app/id1578889450'
      }
    }
  },

  watch: {},

  created() {
    this.checkPhone()
    this.isWeiXin =
      navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
        ? true
        : false
  },

  mounted() {
    // 微信环境则提示 右上角浏览器打开
    if (this.isWeiXin) {
      this.showOpen = true
    } else {
      // 自动跳转
      if (!sessionStorage['tryOpenApp']) {
        sessionStorage['tryOpenApp'] = 1
        const cur = location.href
        location.href = `betterwe://deepLink/main?path=/home`
        setTimeout(() => {
          location.href = cur
        }, 1000)
      }
      this.showFloat = true
    }
  },

  destroyed() {},

  methods: {
    // 得到手机系统
    checkPhone() {
      let self = this
      let agent = navigator.userAgent || navigator.vendor || window.opera
      if (agent != null) {
        let agentName = agent.toLowerCase()
        // 安卓判断
        // (/android/i.test(agentName) || /windows|win32/i.test(agentName))
        // ios判断
        if (
          /iphone/i.test(agentName) ||
          /macintosh|mac os x/i.test(agentName)
        ) {
          self.isIOS = true
        } else {
          self.isAndroid = true
        }
      }
    },
    /* 点击下载按钮 */
    downloadApp() {
      this._doDownload()
    },
    _doDownload() {
      // 微信环境
      let self = this
      let agent = navigator.userAgent || navigator.vendor || window.opera
      if (agent != null) {
        // let agentName = agent.toLowerCase()
        // this.$alert({text: [agentName]})
        if (self.isAndroid) {
          // 微信环境时 弹窗遮罩提示从浏览器打开 并改变hash
          // if (self.isWeiXin) {
          //   self.downloadInWeixin = true
          //   window.location.hash = 'downloading' // 改变hash，便于浏览器打开时直接下载安卓包
          //   return
          // }
          // 安卓包下载地址
          window.location.href = self.androidDownloadUrl
        } else if (self.isIOS) {
          // 微信环境时 弹窗遮罩提示从浏览器打开 并改变hash
          // if (self.isWeiXin) {
          //   self.downloadInWeixin = true
          //   window.location.hash = 'downloading' // 改变hash，便于浏览器打开时直接跳转AppStore
          //   return
          // }
          // 苹果商店链接地址
          // self.$toast(self.iosAppstoreUrl)
          // self.$messagebox.alert('ios:' + self.iosAppstoreUrl)
          window.location.href = self.iosAppstoreUrl
        } else {
          this.$toast('暂不支持，敬请期待~')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.app-download {
  .ad-open {
    width: 100vw;
    position: absolute;
    top: 0;
    right: 1vw;
  }
}
</style>
